module.exports = __webpack_public_path__ + "img/adc-like.933f3696.png";